import { useCallback } from "react";

type TrackWebEngageCategoryViewedProps = {
  categoryName: string;
};

const useWebEngageCategoryViewed = () => {
  const trackWebEngageCategoryViewed = useCallback(({
    categoryName,
  }: TrackWebEngageCategoryViewedProps) => {
    try {
      window.webengage.track("Category Viewed", {
        "Category Name": categoryName,
        "Sub Category Name": categoryName,
      });
    } catch (error) {
      console.log("🚀 ~ categoryViewedWebEngage ~ error:", error); 
    }
  }, [])

  return { trackWebEngageCategoryViewed };
};

export default useWebEngageCategoryViewed;
